import type { Dict } from "../en";

export const msg: Dict["msg"] = {
  // Said in more than one place in the area.
  send: "Gửi",
  post: "Đăng",
  forward: "Chuyển tiếp",
  cancelled: "Đã hủy",
  replacedByNewer: "Đã được thay bằng tin nhắn mới hơn",
  thatDidntWork: "Chưa thực hiện được",
  thatDidntWorkDot: "Chưa thực hiện được.",
  progress: "Tiến độ",
  addNoteOptional: "Thêm ghi chú (không bắt buộc)",
  download: "Tải xuống",
  downloadSize: "Tải xuống ({size})",
  askVantageAboutIt: "Hỏi Vantage về tệp này",
  seconds: "{s} giây",

  // A relay preview, leak or choice card (cardCopy.ts).
  editMessage: "Sửa tin nhắn",
  editPost: "Sửa bài đăng",
  emailTo: "Gửi email cho {name}",
  sendTo: "Gửi cho {name}",
  postTo: "Đăng lên #{channel}",
  beforeSendTo: "Trước khi mình gửi cho {name}",
  beforePost: "Trước khi mình đăng bài này",

  // A capped table's "All N as a report" (deepAsk.ts).
  deepAllN: "tất cả {n}",
  deepAllOfThem: "tất cả",
  deepAsk: "{ask}: {all}, dưới dạng báo cáo.",
  deepAskFullList: "Danh sách đầy đủ ({all}), dưới dạng báo cáo.",

  // Receipts.
  undone: "Đã hoàn tác",
  partlyUndone: "Đã hoàn tác một phần",
  changed: "Đã đổi",
  shared: "Đã chia sẻ",
  couldntDoThat: "Chưa làm được lúc này.",
  onlyYouSee: "Chỉ bạn xem được nội dung này",

  // Forward.
  sentToName: "Đã gửi cho {name}.",
  postedToChannel: "Đã đăng lên #{channel}.",
  otherTeams: "các nhóm khác",
  leakLine: "Nội dung này có thông tin từ {what} mà {target} không xem được.",
  forwardThis: "Chuyển tiếp tin nhắn này",
  couldntForward: "Chưa chuyển tiếp được lúc này.",
  forwardTo: "Chuyển tiếp đến",
  findSomeone: "Tìm người hoặc kênh…",
  peopleAndChannels: "Thành viên và kênh",
  noOneMatches: "Không có người hay kênh nào phù hợp.",
  whatTheyCantSee: "Những gì họ không xem được",
  sendAnyway: "Vẫn gửi",
  to: "Đến",
  change: "Đổi",
  addNote: "Thêm ghi chú",

  // A report's task card.
  durationMinS: "{m} phút {s} giây",
  durationMin: "{m} phút",
  doneIn: "Xong trong {time}",
  taskFailed: "Đã dừng: không hoàn tất được",
  started: "Bắt đầu lúc {time}",
  planning: "đang lên kế hoạch",
  underAMinuteLeft: "còn chưa đến một phút",
  aboutMinLeft: "còn khoảng {n} phút",
  couldntStop: "Chưa dừng được lúc này.",
  stopping: "Đang dừng…",
  stopReport: "Dừng báo cáo",
  stopReportTitle: "Dừng báo cáo này?",
  stopReportBody: "Những gì đã thu thập đến giờ sẽ bị bỏ. Bạn có thể chạy lại sau.",
  runAgain: "Chạy lại",

  // The R3 action cards.
  stepDone: "xong",
  stepFailed: "lỗi",
  stepRunning: "đang chạy",
  stepWaiting: "đang chờ",
  expiredAskAgain: "Đã hết hạn: hãy hỏi lại",
  onlyCanConfirm: "Chỉ {name} mới xác nhận được việc này",
  workingOnIt: "Đang xử lý…",
  answeredBelow: "Đã trả lời bên dưới",
  showNMore: "Xem thêm {n}",
  andNMore: "và {n} mục khác",
  nOfTotal: "{done}/{total}",
  accessInAppOnly: "Thay đổi quyền truy cập chỉ được xác nhận tại đây, trong ứng dụng.",
  partlyDone: "Xong {done}/{total} · {failed} bị lỗi",

  // 👍 / 👎.
  feedbackHint: "Ghi chú của bạn giúp Vantage biết cách trả lời bạn.",
  feedbackHintTeam:
    "Ghi chú của bạn giúp Vantage biết cách trả lời bạn. Khi một đồng đội đồng ý, ghi chú sẽ áp dụng cho cả nhóm {team}.",
  couldntSaveRating: "Chưa lưu được. Hãy thử lại.",
  whatWasOff: "Có gì chưa ổn?",
  pickAny: "Chọn tùy ý",
  reasons: "Lý do",
  reasonWrong: "Sai",
  reasonMissed: "Còn thiếu ý",
  reasonSlow: "Quá chậm",
  reasonTooLong: "Quá dài",
  reasonNotOurWay: "Không đúng cách chúng ta làm",
  noteOptional: "Ghi chú (không bắt buộc)",
  sendFeedback: "Gửi phản hồi",
  thanksFeedback: "Cảm ơn bạn. Góp ý này giúp Vantage làm tốt hơn.",
  goodAnswer: "Câu trả lời tốt",
  goodAnswerOn: "Câu trả lời tốt (đã chọn)",
  needsWork: "Cần cải thiện",
  needsWorkOn: "Cần cải thiện (đã chọn)",

  // A file's card and its lines (files.ts, FileCard.tsx).
  fileBadge: "TỆP",
  filesUpTo: "Tệp tối đa {n} MB.",
  sheets_one: "{n} trang tính",
  sheets_other: "{n} trang tính",
  rows_one: "{n} dòng",
  rows_other: "{n} dòng",
  rowsMore: "{n}+ dòng",
  pages_one: "{n} trang",
  pages_other: "{n} trang",
  pagesMore: "{n}+ trang",
  slides_one: "{n} trang chiếu",
  slides_other: "{n} trang chiếu",
  slidesMore: "{n}+ trang chiếu",
  pageN: "trang {n}",
  pageNOf: "trang {n}/{total}",
  slideN: "trang chiếu {n}",
  slideNOf: "trang chiếu {n}/{total}",
  endPagesOf: "Đây là {n} trang đầu trong {total} trang",
  endSlidesOf: "Đây là {n} trang chiếu đầu trong {total} trang chiếu",
  endFirstPages_one: "Đây là trang đầu tiên",
  endFirstPages_other: "Đây là {n} trang đầu tiên",
  endFirstSlides_one: "Đây là trang chiếu đầu tiên",
  endFirstSlides_other: "Đây là {n} trang chiếu đầu tiên",
  sheetEnd: "Đây là {cap} dòng đầu trong {total} dòng",
  sheetEndMore: "Đây là {cap} dòng đầu trong hơn {total} dòng",
  filePos_one: "Tệp {i}/{n}",
  filePos_other: "Tệp {i}/{n}",
  someone: "Ai đó",
  drawingFirstPage: "Đang dựng trang đầu…",
  openFile: "Mở {name}",

  // The previewer.
  bodyPages: "Các trang",
  bodySlides: "Các trang chiếu",
  bodySheet: "Trang tính",
  bodyPicture: "Hình ảnh",
  bodyText: "Văn bản",
  bodyFile: "Tệp",
  noPreview: "Loại tệp này không có bản xem trước.",
  previousFile: "Tệp trước",
  nextFile: "Tệp sau",
  endOfPreview: "Hết phần xem trước",
  endHelp: "Tải xuống để xem phần còn lại, hoặc hỏi Vantage: Vantage đọc được cả tệp.",
  noPages: "Tệp này không có trang nào để hiển thị.",
  drawingPages: "Đang dựng các trang…",
  drawingPagesNote: "Tệp lớn sẽ mất vài giây; trang nào xong sẽ hiện ngay.",
  pageAlt: "Trang {n}",
  slideAlt: "Trang chiếu {n}",
  drawingPage: "Đang dựng trang {n}",
  thisSheet: "trang tính này",
  sheetUnreadable: "Không đọc được trang tính này để xem trước.",
  noSheets: "Tệp này không có trang tính nào để hiển thị.",
  sheetsLabel: "Các trang tính",
  sheetNamed: "Trang tính {name}",
  sheetEmpty: "Trang tính này trống.",
  loadingMoreRows: "Đang tải thêm dòng…",
  couldntLoadMoreRows: "Không tải thêm dòng được.",
  pictureUnshown: "Không hiển thị được ảnh này ở đây. Hãy tải xuống để xem bản gốc.",
  fullSize: "Kích thước gốc",
  noPagesNoText: "Không dựng được các trang của tệp này, và tệp cũng không có văn bản để hiển thị.",
  itsText: "văn bản của tệp",
  textUnreadable: "Không đọc được văn bản của tệp.",
  noText: "Tệp không có văn bản.",
  textTruncated: "Đây là 200.000 ký tự đầu tiên; hãy tải xuống để có toàn bộ tệp.",
  pagesNotDrawn: "Không dựng được các trang của tệp này.",
  pagesNotDrawnNote: "Đây là văn bản của tệp; hãy tải xuống để xem bản gốc.",

  // A message, its header and its actions.
  sentByEmail: "Gửi qua email",
  byEmail: "qua email",
  automation: "Tác vụ tự động",
  sample: "Mẫu",
  aboutFile: "Về {name}: ",
  showAllSteps: "Xem cả {n} bước",
  plusMore: "+{n} bước nữa",
  emailOff: "Email đang tắt trong Cài đặt.",
  couldntEmail: "Chưa gửi email được lúc này.",
  emailThisToMe: "Gửi tin này vào email của tôi",
  emailMe: "Gửi email cho tôi",
  sentToYourEmail: "Đã gửi vào email của bạn.",
  messageActions: "Thao tác với tin nhắn",
  couldntRetry: "Chưa thử lại được lúc này.",
  tableInCopy: "[bảng]",
  couldntReact: "Chưa thả cảm xúc được.",
  addReaction: "Thêm cảm xúc",
  reactWith: "Thả {emoji}",
  replies_one: "{n} trả lời",
  replies_other: "{n} trả lời",
  lastReply: "Trả lời gần nhất {when}",
  justNow: "vừa xong",
  minAgo: "{n} phút trước",
  atTime: "lúc {time}",
  couldntAsk: "Chưa hỏi được lúc này.",
  yourQuestion: "Câu hỏi của bạn về tin nhắn này",
  askPlaceholder: "Hỏi Vantage về tin nhắn này…",
  ask: "Hỏi",
  askVantageAboutThis: "Hỏi Vantage về tin nhắn này",
  rememberThis: "Ghi nhớ điều này",
  remembered: "Đã ghi nhớ",
  rememberReview: "Quản trị viên sẽ kiểm tra trước khi Vantage ghi nhớ.",
  rememberNothing: "Vantage không thấy điều gì cần ghi nhớ trong tin nhắn đó.",
  couldntRemember: "Chưa ghi nhớ được lúc này.",
  replyInThread: "Trả lời trong luồng",
  copyLink: "Sao chép liên kết",
  linkCopied: "Đã sao chép liên kết",
  copyText: "Sao chép nội dung",
  deleteMessage: "Xóa tin nhắn",
  deleteForEveryone: "Xóa tin nhắn này với mọi người?",
  deleteThis: "Xóa tin nhắn này?",
  couldntDelete: "Chưa xóa được.",
  postedTo: "Đã đăng lên #{channel}",
  postedToBy: "{name} đã đăng lên #{channel}",
  emailedTo: "Đã gửi email cho {name}",
  sentTo: "Đã gửi cho {name}",
  choseBy: "{name} đã chọn: {choice}",
  theyChose: "Đã chọn: {choice}",
  cancelledBy: "{name} đã hủy",
  expired: "Đã hết hạn",
  personWhoAsked: "người đã hỏi",
  subjectLabel: "Tiêu đề:",
  attached: "Đính kèm: {files}",
  onlyCanAnswer: "Chỉ {name} mới trả lời được câu này.",
  onlyCanPost: "Chỉ {name} mới đăng được; bạn có thể hủy.",
  onlyCanSend: "Chỉ {name} mới gửi được; bạn có thể hủy.",
  askPrivately: "Hỏi riêng",
  deleted: "Tin nhắn này đã bị xóa.",
  viaVantage: "qua Vantage, {label}",
  earlierAnswer: "Câu trả lời trước",
  edited: "đã sửa",
  sending: "đang gửi…",
  working: "đang xử lý",
  takingAWhile: "Việc này mất một lúc. Xong mình sẽ đăng ở đây nhé.",
  stop: "Dừng",
  makeTicket: "Tạo ticket",
  couldntMakeTicket: "Chưa tạo được ticket lúc này.",
  askVantage: "Hỏi Vantage",
  markUnreadFromHere: "Đánh dấu chưa đọc từ đây",
  couldntMarkUnread: "Không đánh dấu chưa đọc được.",
  viewTrace: "Xem quá trình xử lý",
};
